/*
 * Public API Surface of inova-core
 */


export * from './truncated-text.module'
export * from './truncated-text.component'

